module.exports = __webpack_public_path__ + "static/img/s1.159cddf0.png";